<template>
	<div>
		<div class="sousuo" style="width: 100%">
			<div style="width: 550px" class="yl-flex flex_between">
				<Input placeholder="搜索账户名称" v-model="name" style="width: 300px">
				<i-button slot="append" icon="ios-search"></i-button>
				</Input>
				<Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
				<Button class='ivu-btn-circle' @click="initSearch">重置</Button>
				<Button class='ivu-btn-circle' type="primary" @click="addAccountButton">添加媒体代码</Button>
			</div>
		</div>
		<div class="multiple">
			<div class="child-div">创建时间</div>
			<RadioGroup v-model="timePeriod">
				<Radio label="0"><span>不限</span></Radio>
				<Radio label="1"><span>今日</span></Radio>
				<Radio label="2"><span>昨日</span></Radio>
				<Radio label="3"><span>本周</span></Radio>
				<Radio label="4"><span>上周</span></Radio>
				<Radio label="5"><span>本月</span></Radio>
				<Radio label="6"><span>上月</span></Radio>
				<Radio label="7"><span>自定义</span></Radio>
				<DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
					placeholder="选择日期" style="width: 200px"></DatePicker>
			</RadioGroup>
		</div>
		<div class="multiple">
			<div class="child-div">操作人</div>
			<Select v-model="uid" style="width: 200px;">
				<Option v-for="item in operaterList" :value="item.id" :key="item.id">
					{{item.username }}-[{{item.id}}]
				</Option>
			</Select>
		</div>
		<div style="width: 100% ;margin-top: 20px;">
			<Table stripe border :columns="columns" :data="datas" ref="table">
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id" :data-index="index"
						@click="getSrcId">编辑</Button>
					<Button type="error" size="small" :data-id="row.id" @click="delSrcId">删除</Button>
				</template>
				<template slot-scope="{row, index}" slot="status" >
					<i-switch v-model="datas[index].status" @on-change="saveOpen($event, index)">
						<span slot="open">开</span>
						<span slot="close">关</span>
					</i-switch>
				</template>
			</Table>
			<div>
				<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
					:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
			</div>
		</div>
		<!--Modal v-model="CreateCostModal" width="1000" title="余额">
			<CreateCost></CreateCost>
		</Modal-->
		<!-- 提现申请 -->
		<Modal v-model="modal" width="500" title="编辑媒体代码">
			<Form :label-width="120">
				<FormItem label="所属账户id">
					<el-select v-model="accountForm.account_id" filterable style="width:100%;"  placeholder="请选择账户id">
						<el-option v-for="item in accountList"   :label="`${item.account_name}--${item.account_id}`"  :value="item.account_id" :key="item.account_id">
							
						</el-option>
					</el-select>
					<!--Select v-model="accountForm.account_id" filterable>
						<Option v-for="item in accountList" :value="item.account_id" :key="item.account_id">
							{{item.account_name }}-[{{item.account_id}}]
						</Option>
					</Select-->
				</FormItem>
				<FormItem label="媒体代码名称">
					<Input placeholder="媒体代码名称" v-model="accountForm.src_name"></Input>
				</FormItem>
				<FormItem label="运营">
					<el-select v-model="accountForm.uid" filterable style="width:100%;"  placeholder="请选择运营">
						<el-option v-for="item in operaterList"   :label="item.username"  :value="item.id" :key="item.id">
							
						</el-option>
					</el-select>
					<!--Select v-model="accountForm.uid">
						<Option v-for="item in operaterList" :value="item.id" :key="item.id">
							{{item.username }}-[{{item.id}}]
						</Option>
					</Select-->
				</FormItem>
				<FormItem label="渠道id">
					<el-select v-model="accountForm.cid" filterable style="width:100%;"  placeholder="请选择渠道id">
						<el-option v-for="item in advCidList"   :label="`${item.username}--${item.id}`"  :value="item.id" :key="item.id">
							
						</el-option>
					</el-select>
					<!--Select v-model="accountForm.cid"  placeholder="请选择渠道id" filterable>
						<Option v-for="item in advCidList" :value="item.id"  :key="item.id">
							{{item.username }}-[{{item.id}}]
						</Option>
					</Select-->
				</FormItem>
				<FormItem label="备注">
					<Input placeholder="备注" v-model="accountForm.remark"></Input>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="srcEditSubmit">提交</Button>
				<Button type="default" @click="modal = false">取消</Button>
			</div>
		</Modal>
	</div>
</template>
<script>
	import {
		mapGetters,
		mapMutations 
	} from "vuex";
	import {
		getAllMediumCode,
		getAccountStatic,
		getAllAccountList,
		getSrcIdList,
		addSrcId,
		getAccountList,
		getSystemDataList,
		getSrcId,
		delSrcId,
		
		getAccount,
		getAllOperater,
		getToutiaoSrc,
		addAccount,
		getCidTypeList,
		saveAccountStatusOpen,
		delAccount
	} from "../../api/advManage";
	export default {
		name: "digital_resource_management",
		props: ['addSrcModalValue'],
		components: {
			
		},
		data() {
			return {
				modal: false,
				name: '',
				timePeriod: '0',
				timePeriodDate: [],
				datas: [],
				operaterList:[],
				srcList:[],
				cidTypeList:[],
				accountList:[],
				advCidList:[],
				uid:[],
				page: 1,
				pageSize: 10,
				pageSizeOpts: [10, 50, 100, 500],
				count: 0,
				accountForm: {
					account_id:'',
					uid:'',
					account_name:'',
					remark:'',
					account_src:[],
				},
				CreateCostModal: false,
				columns: [{
						"title": "媒体代码id",
						"key": "id",
						"align": "center",
						"width": '100px',
					},
					{
						"title": "媒体代码名称",
						"key": "src_name",
						"align": "center",
						"width": '200px',

					},
					{
						"title": "账户id",
						"key": "account_id",
						"align": "center",
						"width": '150px',

					},
					{
						"title": "所属账户名称",
						"key": "account_id",
						"align": "center",
						"width": '200px',

					},
					{
						"title": "操作人",
						"key": "username",
						"align": "center",
						"width": '100px',
					},
					{
						"title": "渠道id",
						"key": "type",
						"align": "center",
						"width": '100px',
					},
					{
						"title": "账户类型",
						"key": "type",
						"align": "center",
						"width": '100px',
					},
					{
						title: 'Action',
						slot: 'action',
						align: 'center',
						"width": '300px',
					}
				],
			}
		},
		computed: {
			...mapGetters(['token','addSrcIdStatus', 'userInfo']),
			addSrcIdStatus() {
			  return this.$store.state.app.addSrcIdStatus;
			},
		},
		mounted: function() {
			this.loadData();
			this.getList();
		},
		watch: {
			addSrcIdStatus() {
				
				this.loadData();
			},
			addSrcModalValue(){
				this.modal = true;
			}
		},
		methods: {
			...mapMutations([
				'setaddSrcIdStatus',
			]),
			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			initSearch() {
				this.name = '';
				this.page = 1;
				this.pageSize = 10;
				this.timePeriod = 0;
				this.timePeriodDate = [];
				this.uid = [];
				this.search();
			},
			createCost() {
				this.CreateCostModal = true;
			},
			async loadData() {
				let that = this;
				 let data = {}
				 data.token = this.token;
				 console.log('aishangni')
				 let res = await getAllOperater(that, data);
				 that.operaterList = res.data.list;
				 res = await getToutiaoSrc(that, data);
				 that.srcList = res.data.list;
				 res = await getCidTypeList(that, data);
				 that.cidTypeList = res.data.list;
				 res = await getAllAccountList(that, data);
				 that.accountList = res.data.list;
				 res = await getSystemDataList(that, data);
				 that.advCidList = res.data.advCidList;
			},
			saveOpen(e, index) {
				console.log(e)
				let item = this.datas[index];
				let that = this;
				let data = {
					token: this.token,
					id: item.id,
					status: item.status
				};
				this.throttle(async function() {
					let res = await saveAccountStatusOpen(that, data);
					if (res.code == 1) {
						that.$Message.success('操作成功');
					}
				}, 200)
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				let res = await getSrcIdList(that, data);
				that.datas = res.data.list;
				that.count = res.count;
			},
			// 编辑账户
			async getSrcId(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let data = {
					token: that.token,
					id: id,
				};
				let res = await getSrcId(that, data);
				console.log(res)
				if (res.code == 1) {
					that.accountForm = res.data.item;
					that.modal = true;
				}
			},
			// 删除账户
			delSrcId(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								id: id
							}
							let res = await delSrcId(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.getList();
							}
						}, 1000);
					}
				})
			},
			addAccountButton() {
				this.accountForm = {};
				this.modal = true;
			},
			async srcEditSubmit() {
				let that = this;
				let data = {
					token: that.token,
					accountForm: that.accountForm,
				};
				let res = await addSrcId(that, data);
				if (res.code == 1) {
					this.modal = false;
					this.setaddSrcIdStatus(Date.parse(new Date()))
					this.getList();
				}
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			search() {
				this.getList();
			}
		},


	}
</script>
<style scoped lang="less">
	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>
